import {isPlainObject, objValueAsArray, objValueAsObject, objValueAsString} from "@utils/object";
import {addUniqueCssClasses} from "@functions/css";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import React from "react";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import PolicyHolderConvictionForm
   from "./parts/policy-holder-conviction-form";
import AddItemButtonComponent from "@components/common/form-controls/buttons/add-item-button";

export const CommonPolicyHolderConvictionsForm = ({
   
   containerAttrs = {},
   sectionHeading = 'Convictions',
   showSectionHeading = true,
   data,
   onChange,
   
   addPolicyHolderConviction,
   handlePolicyHolderConvictionPropChange,
   removePolicyHolderConviction
   
   
}) => {
   
   containerAttrs = isPlainObject(containerAttrs) ? containerAttrs : {};
   
   containerAttrs.className = addUniqueCssClasses(
      objValueAsString(containerAttrs, 'className'),
      'convictions-form-container'
   );
   
   return (
      <div {...containerAttrs}>
         
         {showSectionHeading && (
            <SectionHeading
               text={sectionHeading}
            
            />
         )}
         
         {/* Any motor accidents or claims in the last 5 years? */}
         
         <ScrollableButtonGroupBlock
            containerCssClass="col-12 py-3 extra"
            labelText="Any motoring convictions, driving licence endorsements or fixed penalty points within the last 5 years?"
            required={true}
            controlName="hasMotoringConvictionsInLast5Years"
            options={YES_NO_CHOICE_OPTIONS}
            selectedValues={data.hasMotoringConvictionsInLast5Years}
            onChange={onChange}
         />
         
         {data.hasMotoringConvictionsInLast5Years === 'Yes'
            && data.motorConvictionsList.length !== 0
            && (
               
               <div className="row hidden-box">
                  
                  <div className="col-12 py-3 gap-3 d-flex flex-column">
                     
                     {data.motorConvictionsList?.map((conviction, convictionIndex) => (
                        <PolicyHolderConvictionForm
                           key={convictionIndex}
                           convictionIndex={convictionIndex}
                           conviction={conviction}
                           motorConvictionsListPropName={`motorConvictionsList`}
                           handlePolicyHolderConvictionPropChange={handlePolicyHolderConvictionPropChange}
                           addPolicyHolderConviction={addPolicyHolderConviction}
                           removePolicyHolderConviction={removePolicyHolderConviction}
                        />
                     ))}
                  
                  </div>
               
               
               </div>
            
            )}
         
         {data.hasMotoringConvictionsInLast5Years === 'Yes'
            && data.motorConvictionsList.length === 0
            && (
               
               
               <div className="col-12 py-3 text-danger text-center scrollable" data-block="motorConvictionsList">
                  No conviction record submitted yet!
               </div>
            
            
            )}
         
         {data.hasMotoringConvictionsInLast5Years === 'Yes' && (
            
            
            <div className="col-12 py-3 text-center">
               <AddItemButtonComponent
                  text="Add Conviction"
                  onClick={(e) => addPolicyHolderConviction()}
               />
            </div>
         
         
         )}
      
      </div>
   );
};